import React, { useEffect, createContext, useState } from 'react';
import * as http from 'utils/http';
import config from 'config';
import serialize from '../../../utils/serialize';
import { normalize } from 'utils/converters';

const DriverPoolContext = createContext();

const getAvailableDriversByItinerary = async (itineraryId) =>
  http.get(`${config.API_URL}driver-pool/${itineraryId}`);

const getJourneysByDriver = async (query) =>
  http.get(`${config.API_URL}assignment/journeys/by_driver/?${query}`);

function DriverPoolContextProvider({ children, filters }) {
  const [availableDrivers, setAvailableDrivers] = useState([]);
  const [availableDriversById, setAvailableDriversById] = useState({});
  const [mounted] = useState(true);
  const [fetchingJourneys, setFetchingJourneys] = useState(false);
  const [fetchingDrivers, setFetchingDrivers] = useState(true);
  const [journeysByDriver, setJourneysByDriver] = useState({});

  const dateFilter = (filters || {}).date;

  useEffect(() => {
    const { itineraryId } = filters;
    setFetchingDrivers(true);
    getAvailableDriversByItinerary(itineraryId).then((res) => {
      setAvailableDrivers(res.results);
      setFetchingDrivers(false);
    });
  }, [filters]);

  useEffect(() => {
    async function _fetchJourneys(pickupTimeFrom, driversToFetch) {
      if (!mounted || !pickupTimeFrom || !driversToFetch) {
        return;
      }

      setFetchingJourneys(true);
      driversToFetch = driversToFetch.map((x) => x.id);

      const journeyFilters = serialize({
        pickup_time_from: pickupTimeFrom,
        drivers: driversToFetch,
      });

      try {
        const journeys = await getJourneysByDriver(journeyFilters);
        mounted && setJourneysByDriver(journeys);
      } catch (err) {
      } finally {
        mounted && setFetchingJourneys(false);
      }
    }
    _fetchJourneys(dateFilter, availableDrivers);
  }, [mounted, dateFilter, availableDrivers]);

  useEffect(() => {
    setAvailableDriversById(normalize(availableDrivers));
  }, [availableDrivers]);

  return (
    <DriverPoolContext.Provider
      value={{
        availableDrivers,
        availableDriversById,
        fetchingJourneys,
        journeysByDriver,
        isLoading: fetchingDrivers,
      }}
    >
      {children}
    </DriverPoolContext.Provider>
  );
}

export { DriverPoolContextProvider };
export default DriverPoolContext;
